// frontend/src/components/ProfileBlockDisplays/TextBlockDisplay.js
import React from 'react';

const TextBlockDisplay = ({ content }) => {
    if (!content || (!content.title && !content.text)) return null;

    return (
        <div className="p-6 md:p-8 rounded-xl border border-outlineVariant bg-surface text-surface-on">
            {content.title && (
                <h3 className="text-headline-small font-bold mb-4 text-surface-on">
                    {content.title}
                </h3>
            )}
            {content.text && (
                <p className="text-body-large text-surface-on whitespace-pre-wrap leading-relaxed">
                    {content.text}
                </p>
            )}
        </div>
    );
};

export default TextBlockDisplay;
